(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (function () {
    function initVideoPosters() {
      const videos = document.querySelectorAll('.slide__video');
      videos.forEach(video => {
        const container = video.closest('.slide__video-container');
        const poster = container?.querySelector('.slide__video-poster');
        if (!poster || poster.classList.contains('processed')) return;

        const hidePoster = () => {
          if (poster && !poster.classList.contains('hidden')) {
            poster.classList.add('hidden');
          }
        };

        video.addEventListener('canplay', hidePoster);
        video.addEventListener('play', hidePoster);
        video.addEventListener('loadeddata', hidePoster);

        if (video.readyState >= 3) hidePoster();

        poster.classList.add('processed');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVideoPosters);
    } else {
      initVideoPosters();
    }

    document.addEventListener('shopify:section:load', initVideoPosters);

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          initVideoPosters();
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
